<template>
    <!-- spec 2026-10-16 seller-order-cancel-actor-reason §5: cancel one App order
         from /seller/orders. Same picker as the BO cancel modal (OrderTables.vue
         CancelReasonTable, via utils/orderCancelReason) minus claim (5) — the
         claim flow needs photos and stays in the BO — plus the required free
         text. The dialog only collects the form: Orders.vue validates, asks
         for the swal confirm and POSTs. Appended to <body> (the panel it opens
         from sits inside an expanded table row). -->
    <el-dialog
        :visible="visible"
        :title="$t('seller_orders.cancel_dialog_title', { order: orderLabel })"
        :append-to-body="true"
        :close-on-click-modal="false"
        width="520px"
        custom-class="so-cancel-dialog"
        @update:visible="v => $emit('update:visible', v)"
    >
        <div data-testid="so-cancel-dialog">
            <div class="form-group mb-3">
                <label class="form-control-label d-block" for="so-cancel-type">{{ $t("seller_orders.cancel_type_label") }}</label>
                <el-select
                    id="so-cancel-type"
                    v-model="form.bo_cancel_reason_id"
                    class="w-100"
                    :placeholder="$t('seller_orders.cancel_reason_placeholder')"
                    data-testid="so-cancel-type"
                >
                    <el-option v-for="option in reasons" :key="option.ID" :label="option.Name" :value="option.ID"></el-option>
                </el-select>
            </div>
            <div class="form-group mb-0">
                <label class="form-control-label d-block" for="so-cancel-note">{{ $t("seller_orders.cancel_note_label") }}</label>
                <el-input
                    id="so-cancel-note"
                    v-model="form.cancel_reason"
                    type="textarea"
                    :rows="3"
                    :maxlength="maxLen"
                    :placeholder="$t('seller_orders.cancel_note_placeholder')"
                    data-testid="so-cancel-note"
                ></el-input>
                <small class="text-muted d-block text-right">{{ noteLength }} / {{ maxLen }}</small>
            </div>
        </div>
        <span slot="footer">
            <base-button type="secondary" :disabled="submitting" @click="$emit('update:visible', false)">
                {{ $t("seller_orders.cancel_close") }}
            </base-button>
            <base-button type="danger" :disabled="submitting" data-testid="so-cancel-submit" @click="submit">
                <i v-if="submitting" class="fa fa-spinner fa-spin mr-1"></i>{{ $t("seller_orders.cancel_confirm_btn") }}
            </base-button>
        </span>
    </el-dialog>
</template>

<script>
import { Dialog, Input, Select, Option } from "element-ui";
import { CANCEL_NOTE_MAX, cancelPayload, emptyCancelForm, sellerCancelReasons } from "@/utils/orderCancelReason";

export default {
    name: "SellerOrderCancelDialog",
    components: {
        [Dialog.name]: Dialog,
        [Input.name]: Input,
        [Select.name]: Select,
        [Option.name]: Option
    },
    props: {
        visible: { type: Boolean, default: false },
        // The list row being cancelled (order_no / uuid for the title).
        order: { type: Object, default: null },
        submitting: { type: Boolean, default: false }
    },
    data() {
        return {
            form: emptyCancelForm(),
            reasons: sellerCancelReasons(),
            maxLen: CANCEL_NOTE_MAX
        };
    },
    computed: {
        orderLabel() {
            const o = this.order || {};
            return o.order_no || o.uuid || "";
        },
        noteLength() {
            return Array.from(String(this.form.cancel_reason || "")).length;
        }
    },
    watch: {
        // A fresh form each time the dialog opens.
        visible(v) {
            if (v) this.form = emptyCancelForm();
        }
    },
    methods: {
        submit() {
            this.$emit("submit", cancelPayload(this.form));
        }
    }
};
</script>

<style>
/* Unscoped: the dialog is appended to <body>. Class name is page-specific. */
.so-cancel-dialog .el-dialog__body {
    padding-top: 8px;
    padding-bottom: 8px;
}
</style>
